import { ReactComponent as BusinessCartMobileSvg } from '../../assets/images/business-cart-mobile.svg';

export const BusinessCartMobileIcon: SvgIcon = (props) => {
    return <BusinessCartMobileSvg {...props} />;
};
